import * as React from 'react';
import {connect, useSelector} from 'react-redux';

import type {Dispatch} from 'redux';

import {eavHasValue} from 'nutshell-core/eav/eav-has-value';

import type {NutshellState} from '../../../store';

import * as createNewActions from '../../creator/creator-actions';
import {useGetSelectedFields} from '../../creator/customize-fields/use-get-selected-fields';
import type {FlashMessage} from '../../creator/types';
// @ts-expect-error
import * as dashboardSelectors from '../../master-dashboard/dashboard-selectors';

import {handleFormSubmissionError} from '../handle-form-submission-error';

import {AccountFormConnected} from './account-form-connected';
import {getLinksForSubmission} from './helpers';

type OwnProps = {
    onSaveCallback: (entity: any, jumpToUrl: boolean) => any;
    onCancelClick: () => void;
};

type DispatchProps = {
    pushFlashMessage: (arg1: FlashMessage) => void;
    onSubmit: (arg1: any) => any;
    onSubmitSuccess: (arg1: any) => any;
    onSubmitFail: (errors: any[], dispatchFunction: Dispatch<any>, jqXHRError: any) => any;
};

type Props = OwnProps & DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch, ownProps: OwnProps): DispatchProps {
    return {
        // Not actually using dispatch yet, this is a temp solution
        onSubmit: (data: any) => {
            const account = {
                ...data,
                links: getLinksForSubmission(data.links, 'accounts'),
                addresses: data.addresses ? data.addresses.filter(eavHasValue) : undefined,
                emails: data.emails ? data.emails.filter(eavHasValue) : undefined,
                phones: data.phones ? data.phones.filter(eavHasValue) : undefined,
                urls: data.urls ? data.urls.filter(eavHasValue) : undefined,
            } as const;

            return (
                $.ajax({
                    url: '/rest/accounts',
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({data: account}),
                })
                    // Add the jqXHR object and account data to the response, so that it can
                    // be used in the onSubmitSuccess handler
                    .then((response, status, jqXHR) => {
                        return {response, jqXHR, account};
                    })
                    .fail(() => {
                        // TODO: Figure out how we want to display errors to the user. This
                        // will almost certainly involve looking at that actual jqXHR object,
                        // but we need to work with that object here and return out something
                        // that redux form is okay with. Because, the jqXHR object causes a
                        // 'Maximum call stack size exceeded error'
                        return 'Error saving';
                    })
            );
        },
        onSubmitSuccess: ({response, jqXHR, postData}: any) => {
            // If we have a response back, lets use it
            const contact =
                jqXHR.status !== 204
                    ? // Pretty big assumption here that the response will have the newly
                      // created contact at index 0
                      response.accounts[0]
                    : postData;

            // Save callback
            ownProps.onSaveCallback(contact, true);
        },
        onSubmitFail: (errors, dispatchFunction, jqXHRError: any) => {
            handleFormSubmissionError(dispatch, jqXHRError, errors);
        },
        pushFlashMessage: (flashMessage: FlashMessage) => {
            dispatch(createNewActions.pushFlashMessage(flashMessage));
        },
    };
}

export function AccountFormComponent(props: Props) {
    const accountsSchema = useSelector((state: NutshellState) =>
        dashboardSelectors.getAccountsSchema(state)
    );

    const {fields, loading: isLoading} = useGetSelectedFields('ACCOUNT');

    return (
        <AccountFormConnected
            schema={accountsSchema}
            selectedFields={fields}
            isLoading={isLoading}
            onSaveCallback={props.onSaveCallback}
            onCancelClick={props.onCancelClick}
            pushFlashMessage={props.pushFlashMessage}
            onSubmit={props.onSubmit}
            onSubmitSuccess={props.onSubmitSuccess}
            // @ts-expect-error
            onSubmitFail={props.onSubmitFail}
        />
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps);
export const AccountForm = connector(AccountFormComponent);
